module.exports = __webpack_public_path__ + "img/herb-mint-350x184.f9ded9e0.jpg";